import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import Orders from "../components/Orders/Orders";
import CommonFooter from "../components/CommonFooter/CommonFooter";

const UserOrders = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <Orders />
      <CommonFooter />
    </div>
  );
};

export default UserOrders;
